import React, { useState } from "react"
import { Icon } from "antd"
import styled, { css } from "styled-components"
import { Link } from "gatsby"
import Logo from "../../assets/logo.svg"

import { media } from "../../components/mediaStylesNew"
import { colors } from "../../components/Color"

const HeaderBox = styled.div`
  height: 180px;
  display: flex;
  align-items: center;
  padding: 0 15px 0 60px;
  justify-content: space-between;
  ${media.desktop`
    padding: 0 15px 0 15px;
    height: 100px;
    .desktop-only {
      display: none;
    }
  `}
  ${({ theme }) =>
    theme === "light"
      ? css`
          background: ${colors.beige};
        `
      : theme === "dark"
      ? css`
          background: ${colors.coal};
        `
      : theme === "teal"
      ? css`
          background: ${colors.teal};
        `
      : null}

  @media (min-width: 768px) {
    .mobile-only {
      display: none;
    }
  }
`

const LogoWrapper = styled.div`
  width: 250px;
  height: 68px;

  ${media.desktop`
    width: 102px;
    height: 27px;
  `};
`

const NewHeader = ({
  logo,
  _rawMenuItems,
  backgroundTheme,
  additionalInfo,
}) => {
  const [mobileMenuActive, setMobileMenuActive] = useState(false)
  const filter = backgroundTheme !== "light" ? "invert(1)" : null

  return (
    <>
      <HeaderBox theme={backgroundTheme}>
        <Link to="/">
          <LogoWrapper>
            <Logo width="100%" height="100%" style={{ filter }} />
          </LogoWrapper>
        </Link>
        <span class="mobile-only">
          <Icon type="menu" onClick={() => setMobileMenuActive(true)} />
        </span>
      </HeaderBox>
    </>
  )
}

export default NewHeader
